import {
  shouldAllowRedirect,
  resetRedirectCounter,
} from "./redirectPrevention";

let navigateFunction: ((path: string) => void) | null = null;

export const setNavigateFunction = (navigate: (path: string) => void) => {
  navigateFunction = navigate;
};

export const safeNavigate = (path: string) => {
  // Reset counter on successful navigation to login
  if (path === "/login") {
    resetRedirectCounter();
  }

  // Check if we should allow this redirect
  if (!shouldAllowRedirect(path)) {
    return; // Prevent the redirect
  }

  // Use React Router navigate if available, fallback to window.location
  if (navigateFunction && window.location.pathname !== path) {
    navigateFunction(path);
  } else if (window.location.pathname !== path) {
    window.location.href = path;
  }
};
